<template lang="pug">
el-container(style="height: 100vh" direction="vertical")
  publicHeader
  
  el-main
    .error500
      h1 500
      h2 Internal Server Error
      p Current page can't be displayed due to trouble of programs or server.<br>We are sorry for the inconvenience.

  publicFooter

</template>

<script>
import Header from '../public/Header.vue'
import Footer from '../public/Footer.vue'

export default {
  data() {
    return {

    }
  },
  title() {
    return '500'
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.error500 {
  width: 500px;
  margin: 0 auto;
  text-align: center;

  h1 {
    font-size: 72px;
  }

  p.go {
    margin-top: 50px;
    font-size: 14px;
  }
}
</style>

